// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-tile {
  position: relative;
  background-color: #16213e;
  border-radius: 12px;
  overflow: hidden;
  aspect-ratio: 16 / 9;
  width: 100%;
  height: 100%;
  min-height: 120px;
  min-width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Gérer les espaces dans la grille */
  align-self: stretch;
  justify-self: stretch;
}

.video-tile-large {
  min-width: 400px;
}

.video-tile video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-tile-local video {
  transform: scaleX(-1);
}

.video-tile video.video-hidden {
  display: none;
}

.video-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0f3460 0%, #16213e 100%);
}

.avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #e94560 0%, #0f3460 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: bold;
  color: white;
  text-transform: uppercase;
}

.video-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 8px 12px;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.video-name {
  color: white;
  font-size: 14px;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.video-status {
  display: flex;
  gap: 8px;
}

.status-icon {
  font-size: 14px;
  opacity: 0.9;
}

.status-icon.muted {
  color: #e94560;
}

.status-icon.video-off {
  color: #e94560;
  text-decoration: line-through;
}

/* Bouton plein écran pour le partage d'écran */
.fullscreen-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 18px;
  z-index: 10;
  opacity: 0;
  transition: opacity 0.2s ease, background 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-tile:hover .fullscreen-btn {
  opacity: 1;
}

.fullscreen-btn:hover {
  background: rgba(0, 0, 0, 0.9);
  transform: scale(1.1);
}

@media (max-width: 768px) {
  .fullscreen-btn {
    width: 28px;
    height: 28px;
    font-size: 14px;
  }

  .video-info {
    padding: 6px 8px;
  }

  .video-name {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .avatar {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }

  .video-name {
    font-size: 12px;
  }

  .status-icon {
    font-size: 12px;
  }
}

/* Plein écran : agrandir la tuile */
.video-tile:fullscreen {
  width: 100vw;
  height: 100vh;
  border-radius: 0;
  background: #000;
}

.video-tile:fullscreen video,
.video-tile:fullscreen .video-placeholder {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@media (max-width: 768px) {
  .fullscreen-btn {
    width: 28px;
    height: 28px;
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/VideoTile.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,mDAAmD;EACnD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".video-tile {\r\n  position: relative;\r\n  background-color: #16213e;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  aspect-ratio: 16 / 9;\r\n  width: 100%;\r\n  height: 100%;\r\n  min-height: 120px;\r\n  min-width: 160px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  /* Gérer les espaces dans la grille */\r\n  align-self: stretch;\r\n  justify-self: stretch;\r\n}\n\r\n.video-tile-large {\r\n  min-width: 400px;\r\n}\r\n\r\n.video-tile video {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.video-tile-local video {\r\n  transform: scaleX(-1);\r\n}\r\n\r\n.video-tile video.video-hidden {\r\n  display: none;\r\n}\r\n\r\n.video-placeholder {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: linear-gradient(135deg, #0f3460 0%, #16213e 100%);\r\n}\r\n\r\n.avatar {\r\n  width: 80px;\r\n  height: 80px;\r\n  border-radius: 50%;\r\n  background: linear-gradient(135deg, #e94560 0%, #0f3460 100%);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 32px;\r\n  font-weight: bold;\r\n  color: white;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.video-info {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  padding: 8px 12px;\r\n  background-color: rgba(0, 0, 0, 0.85);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.video-name {\r\n  color: white;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.video-status {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.status-icon {\r\n  font-size: 14px;\r\n  opacity: 0.9;\r\n}\r\n\r\n.status-icon.muted {\r\n  color: #e94560;\r\n}\r\n\r\n.status-icon.video-off {\r\n  color: #e94560;\r\n  text-decoration: line-through;\r\n}\r\n\r\n/* Bouton plein écran pour le partage d'écran */\r\n.fullscreen-btn {\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 8px;\r\n  background: rgba(0, 0, 0, 0.7);\r\n  border: none;\r\n  color: white;\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n  z-index: 10;\r\n  opacity: 0;\r\n  transition: opacity 0.2s ease, background 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.video-tile:hover .fullscreen-btn {\r\n  opacity: 1;\r\n}\r\n\r\n.fullscreen-btn:hover {\r\n  background: rgba(0, 0, 0, 0.9);\r\n  transform: scale(1.1);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .fullscreen-btn {\r\n    width: 28px;\r\n    height: 28px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .video-info {\r\n    padding: 6px 8px;\r\n  }\r\n\r\n  .video-name {\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .avatar {\r\n    width: 50px;\r\n    height: 50px;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .video-name {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .status-icon {\r\n    font-size: 12px;\r\n  }\r\n}\n\r\n/* Plein écran : agrandir la tuile */\r\n.video-tile:fullscreen {\r\n  width: 100vw;\r\n  height: 100vh;\r\n  border-radius: 0;\r\n  background: #000;\r\n}\r\n\r\n.video-tile:fullscreen video,\r\n.video-tile:fullscreen .video-placeholder {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .fullscreen-btn {\r\n    width: 28px;\r\n    height: 28px;\r\n    font-size: 14px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
